module.exports = "\n<div class=\"card\">\n    <div class=\"card-header\">{{'webpanel.analytics.' + activeMetric|translate|capitalizeFirst}}</div>\n    <div class=\"card-body\">\n        <app-dashboard-chart-pane [data]=\"data\" [interval]=\"activeInterval\" [partition]=\"'main.'+ toCamelCase(activeMetric)\"></app-dashboard-chart-pane>\n    </div>\n</div>\n<app-dashboard-charts-selector [metrics]=\"metricsList\" (selected)=\"metricChanged($event)\"></app-dashboard-charts-selector>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard-charts/dashboard-charts.component.html
// module id = ./src/app/components/dashboard-charts/dashboard-charts.component.html
// module chunks = main